import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Notyf } from "notyf";
// Utils
import { createCategorie } from "~/api/menu";
//svg
import closeIcon from "~/assets/svg/close.svg";
import upload from "~/assets/svg/upload-lg.svg";
//CSS
import "../_add_item.scss";
import { useLoadMedia } from "~/hooks/loadMedia";

const AddCategorie = (props) => {
  const notyf = new Notyf({
    position: {
      x: "center",
      y: "top",
    },
    duration: 3000,
    dismissible: true,
  });

  const [load, setLoad] = useState(false);
  const [image, setImage] = useState("");
  const [bannersImage, setBannersImage] = useState("");
  const [loadImage, setLoadImage] = useState();
  const [loadBannerImage, setLoadBannerImage] = useState();

  const [categorie, setCategorie] = useState("");

  const {
    loadMedia,
    handleMedia,
    handleSelectedMedia,
    //uppdateInfo,
    //setUpdateInfo,
    setLoadMedia,
    Media,
  } = useLoadMedia({
    categories: {
      boolean: loadImage,
      action: setLoadImage,
      name: "categories",
      updateValue: setImage,
    },
    banners: {
      boolean: loadBannerImage,
      action: setLoadBannerImage,
      name: "banners",
      updateValue: setBannersImage,
    },
  });

  const handleAdd = (e) => {
    e.preventDefault();

    let exists = props.categories.find((item) => {
      return item.name.toLowerCase() === categorie.toLowerCase();
    });
    if (exists) {
      notyf.error("Cette catégorie est déjà ajouté");
      return;
    }

    setLoad(true);

    (async function todo() {
      let iconName = "";
      let bannerName = "";

      iconName = image?.categories;
      bannerName = bannersImage?.banners;

      let menuActive = localStorage.getItem("menuActive");
      let newCategorie = {
        name: categorie,
        iconUrl: iconName,
        bannerUrl: bannerName,
        storeId: props.storeId,
        menuId: menuActive,
      };

      await createCategorie(newCategorie)
        .then((res) => {
          let categories = res.data.categories;
          props.init(categories);
          notyf.success(res.data.message);
        })
        .catch((err) => {
          notyf.error(err.message);
        });

      setLoad(false);
      props.handleCloseAdd(false);
    })();
  };

  return (
    <Modal
      className="modal add-category"
      show={props.showAdd}
      onHide={() => props.handleCloseAdd(false)}
    >
      <Modal.Header closeButton>
        <h1 className="modal--title">Ajout catégorie </h1>
        <img
          onClick={() => props.handleCloseAdd(false)}
          className="modal--close"
          alt="close-svg"
          src={closeIcon}
        />
      </Modal.Header>
      {loadMedia ? (
        <Media
          setLoadMedia={setLoadMedia}
          handleSelectedMedia={handleSelectedMedia}
        />
      ) : (
        <form onSubmit={handleAdd}>
          <Modal.Body className="fade-in">
            <div className="inputs">
              <label>Nom de la catégorie</label>
              <input
                required
                name="name"
                value={categorie}
                onChange={(e) => setCategorie(e.target.value)}
              />
            </div>
            <p>Selectionnez un icon</p>
            <div className="styles--body-upload">
              <label htmlFor="upload--logo">
                <img
                  alt="upload-file"
                  src={upload}
                  name="categories"
                  onClick={handleMedia}
                />
              </label>
              {image !== "" && (
                <img src={image.categories} alt="" style={{ width: 40 }} />
              )}
            </div>

            <p>Selectionnez une bannière</p>
            <div className="styles--body-upload">
              <label htmlFor="upload--logo">
                <img
                  alt="upload-file"
                  src={upload}
                  name="banners"
                  onClick={handleMedia}
                />
              </label>
              {bannersImage !== "" && (
                <img src={bannersImage.banners} alt="" style={{ width: 40 }} />
              )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button className="modal--btn-validate large" disabled={load}>
              {load ? (
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                "Ajouter"
              )}
            </button>
          </Modal.Footer>
        </form>
      )}
    </Modal>
  );
};

export default AddCategorie;
